import { EMPTY_VALUE } from '@bridge/utils';

import { Body } from '../typography';
import clsxm from '../utils/style';

import type { BodyProps } from '../typography/Body';

export interface EmptyValueProps {
  className?: string;
  size?: BodyProps['size'];
}

export function EmptyValue({ className, size = 'sm' }: EmptyValueProps) {
  return (
    <Body className={clsxm('text-content-tertiary', className)} size={size}>
      {EMPTY_VALUE}
    </Body>
  );
}
